import React from 'react';
import { Button } from '@material-tailwind/react';
import Modal from '@components/widgets/Modal';

interface UploadErrorModalProps {
  open: boolean;
  onClose: () => void;
  primaryColor: string;
}

const UploadErrorModal: React.FC<UploadErrorModalProps> = ({
  open,
  onClose,
  primaryColor
}) => {
  return (
    <Modal size="md" open={open} onClose={onClose} hideClose>
      <div className="pt-6 flex flex-col items-center gap-4">
        <h2 className="text-grey-900 font-semibold flex gap-2 flex-row w-full">
          Upload Unsuccessful
        </h2>
        <p className="text-gray-800">
          It seems your image couldn&apos;t be uploaded. This may be due to a
          slow or unstable internet connection. Please check your connection and
          try again.
        </p>
        <Button
          className="w-full normal-case font-semibold text-white"
          style={{ backgroundColor: primaryColor }}
          onClick={onClose}>
          Try Again
        </Button>
      </div>
    </Modal>
  );
};

export default UploadErrorModal;